export const visitHasBeforeQuestionnaires = (state, getters, rootState, rootGetters) => (visit) => {
  const encounter = rootGetters['patientSummary/getEncounter'](visit);

  if (encounter && encounter.status === 'skipped'){
    return false;
  }

  return true;
}

export const visitHasAfterQuestionnaires = (state, getters, rootState, rootGetters) => (visit) => {
  const encounter = rootGetters['patientSummary/getEncounter'](visit);

  if (encounter && encounter.status === 'skipped'){
    return false;
  }

  return [2,6].includes(visit);
}